// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import NavMenuController from "./nav_menu_controller"
application.register("nav-menu", NavMenuController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CounterController from "./counter_controller"
application.register("counter", CounterController)

import LeaderboardSearchController from "./leaderboard_search_controller"
application.register("leaderboard-search", LeaderboardSearchController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import { registerControllers } from "@radioactive-labs/plutonium"
registerControllers(application)
